module.exports = __webpack_public_path__ + "img/activity_green.f7d5f27d.png";